import React from "react";

/** Product form label — red asterisk only when `required` is true. */
const FormLabel = ({ htmlFor, children, required = false, className = "oms-form-label" }) => (
  <label htmlFor={htmlFor} className={className}>
    {children}
    {required && (
      <span className="product-form-page__required" aria-hidden>
        {" "}
        *
      </span>
    )}
  </label>
);

export default FormLabel;
